import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const interview = createSlice({
  name: 'interview',
  initialState,
  reducers: {
    getInterviewRequest: handlers.getInterviewRequest,
    getInterviewSuccess: handlers.getInterviewSuccess,
    getInterviewFailure: handlers.getInterviewFailure,
  },
});

export const { actions } = interview;

export const { getInterviewRequest, getInterviewSuccess, getInterviewFailure } = actions;

export default interview.reducer;
